export type SortDir = "asc" | "desc";

export interface SortableColumn<K extends string> {
  label: string;
  sortKey?: K;
}

// 거래내역/일별요약 둘 다 정렬 가능한 컬럼 헤더가 필요해서 공통 렌더러로 뺐다 — 정렬 안 되는
// 컬럼은 그냥 텍스트, 정렬 되는 컬럼은 버튼으로 만들어 클릭 시 onSort(key)를 호출한다. 현재
// 정렬 기준 컬럼에는 방향 화살표를 붙인다.
export function renderSortableHeaderRow<K extends string>(
  columns: SortableColumn<K>[],
  sortBy: K,
  sortDir: SortDir,
  onSort: (key: K) => void,
): HTMLTableRowElement {
  const tr = document.createElement("tr");
  for (const col of columns) {
    const th = document.createElement("th");
    if (col.sortKey) {
      const isActive = col.sortKey === sortBy;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sort-th-btn" + (isActive ? " active" : "");
      btn.textContent = isActive ? `${col.label} ${sortDir === "asc" ? "▲" : "▼"}` : col.label;
      btn.addEventListener("click", () => onSort(col.sortKey!));
      th.appendChild(btn);
    } else {
      th.textContent = col.label;
    }
    tr.appendChild(th);
  }
  return tr;
}
